
<div class="centr">
        <div class="circle">
    <p class="roboto-normal-azure-15px" style="text-align: center; color: black;">You currently don't have any accounts yet, please import existing accounts or create a new</p>
    <p style="text-align: center;">account.</p>
    <br>

    <div class="col-md-12" style="text-align: center;">
        <br>
        <div class="row"style="text-align: center;">
          <div class="col-md-6">
            <button type="button" class="btn btn-outline-p" (click)="setCarrierCodeFocus()" >Import existing account</button>
          </div>
          <div class="col-md-6">
            <a [routerLink]="['/carrier/account/add']">
            <button type="button" class="btn btn-primary" style="background-color: #1D3F94;" >Create carrier account</button>
              </a>
          </div>
         
        </div>
       </div>
    </div>
</div>